<template>
	<v-app>
		<div class="default-layout">
			<v-layout>
				<Header />
				<v-main :class="mainClasses" style="min-height: 300px">
					<slot />
				</v-main>
			</v-layout>
		</div>

		<!-- Add the notification component -->
		<OfflineNotifications />
	</v-app>
</template>

<script setup>
import { useAuthGuard } from '~/composables/auth/useAuthGuard'

const route = useRoute()
const mainClasses = computed(() => {
	// align content to top if route meta has contentAlign set to 'top'
	// leaving this here for flexibility in case we want to have
	// some pages with centered content in the future
	// change the alignment and justify classes as needed based on your design requirements
	const alignTop = route.meta?.contentAlign === 'top'
	return alignTop
		? 'd-flex align-start justify-start'
		: 'd-flex align-start justify-start'
})

await useAuthGuard()
</script>
<style lang="css" scoped>
.default-layout {
	min-height: 100vh;
	display: flex;
	flex-direction: column;
}
</style>
